import axios, { config } from '..';
import {
  FETCH_SET_SUCCESS,
  FETCH_SET_FAILED,
  CLEAR_SET,
  CLEAR_ADD_TRACK,
  CLEAR_UPDATE_SET,
  CLEAR_RELEASE,
} from '../../actionTypes';

export default (id) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_SET });
    dispatch({ type: CLEAR_ADD_TRACK });
    dispatch({ type: CLEAR_UPDATE_SET });
    dispatch({ type: CLEAR_RELEASE });

    const response = await axios.get(`/providers/sets/${id}`, config);
    const {
      data: { message, data },
    } = response;

    dispatch({
      type: FETCH_SET_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: FETCH_SET_FAILED, error });
  }
};
